import axios from 'axios'
import { Toast } from 'vant'
import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import {getToken} from './auth'
// axios.defaults.withCredentials=true;
// 创建axios实例

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

var CancelToken = axios.CancelToken;
var source = CancelToken.source();

// request拦截器
service.interceptors.request.use(
  config => {
    let token=store.getters&&store.getters.token?store.getters.token:getToken()
    if (token) {
        config.url = config.url + ';jsessionid=' + token
    }
    if(store.getters.popupLogin&&config.url.indexOf('/code/send')<0&&config.url.indexOf('/user/login')<0){
        config.cancelToken = source.token
        source.cancel("未登录取消请求")
    }
    return config
  },
  error => {
    debugger
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    switch (res.code) {
      case '200':
        return response.data
      case '300':
        Toast(res.mng)
        return Promise.reject('error')
      case '500':
        Toast(res.mng)
        return Promise.reject('error')
      case '20011':
        Toast(res.mng)
        return Promise.reject('error')
      case '50008': //需要微信登录权限
        console.warn("50008 router.fullPath:"+router.currentRoute.fullPath);
        store.dispatch('removeToken')
        // let go0=router.currentRoute.fullPath
        // router.push({path:"/login",query:{state:0,go:go0}})
        store.dispatch('openPopupLogin',true)
        return Promise.reject('error')
      case '50014'://需要微信用户绑定的权限
        // let go1=router.currentRoute.fullPath
        // router.push({path:"/login",query:{state:1,go:go1}})
        store.dispatch('openPopupLogin',true)
        return Promise.reject('error')
      default:
        Toast('未知错误')
        return Promise.reject('error')
    }
  },
  error => {
    if(error.message&&error.message=='未登录取消请求'){
        Toast.clear()
        return Promise.reject('error')
    }
    if(!error.response||error.response.status!=404){
          Toast('网络连接失败:'+error.message)
    }
    console.log('服务端err:' + error)
    return Promise.reject('error')
  }
)

const http= (Vue) => {
    Object.defineProperties(Vue.prototype, {
      $http: {
        value: service
      }
    })
}
export { http }

export default service
